var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// /home/giant/builds/t1_QpaSbS/0/vivesa/mcepharma.com/~/enquire.js/src/index.js
// module id = 5
// module chunks = 0